// src/components/Avatar.js
import React from 'react';

const DEFAULT_AVATAR = '/images/user-circle-svgrepo-com.svg'; // from public/images

export default function Avatar({
  src,
  alt = 'User avatar',
  size = 96,
  className = '',
  style = {},
}) {
  const finalSrc = src || DEFAULT_AVATAR;

  return (
    <img
      src={finalSrc}
      alt={alt}
      loading="lazy"
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'cover',
        display: 'block',
        ...style,
      }}
    />
  );
}
